<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />
<!-- Begin Page Content -->
<div class="container-fluid">
  <!-- Page Heading -->

  <!-- DataTales Example -->
  <div>
    <!-- <div class="card-header py-3">
      <h1 class="text-gray-800" style="display: inline-block">
        Manage Operation Data
      </h1>
      <button
        type="button"
        class="btn btn-primary m-2"
        style="float: right"
        [routerLink]="['/opdata', 'opdata-add']"
      >
        Add Data
      </button>

      <button
        type="button"
        class="btn btn-primary m-2"
        style="float: right"
        [routerLink]="['/opdata', 'import']"
      >
        Import Data
      </button>
    </div> -->

    <div class="row" style="margin-top: 10px">
      <div style="height: 15px"></div>
      <div class="col-12 d-flex align-items-center">
        <!-- <div *ngIf="!showdivplant" class="d-flex align-items-center"> -->

        <!-- Commented on 20th April 2026 for the breadcrumb changes -->
        <!-- <div class="d-flex align-items-center">
          <label for="name" class="form-label">Plant:</label>
          <select
            class="form-select border border-dark"
            name="plantid"
            style="width: 350px; margin-left: 17px"
            (change)="gettrainsbyplantId($event)"
          >
            <option selected>Select Plant</option>
            <option
              *ngFor="let plant of plants"
              [value]="plant.Id"
              [selected]="plant.Id === convertedPlantId"
            >
              {{ plant.Name }}
            </option>
          </select>
          <label for="train" class="form-label" style="margin-left: 15px"
            >Train:</label
          >
          <select
            class="form-select border border-dark"
            name="trainid"
            style="width: 350px; margin-left: 15px; margin-right: 15px"
            (change)="getSelectedId($event)"
          >
            <option selected>Select Train</option>
            <option
              *ngFor="let train of allTrainList"
              [value]="train.Id"
              [selected]="train.Id === ConvertedtrainId"
            >
              {{ train.Name }}
            </option>
          </select>
        </div> -->

        <!-- <div *ngIf="showDvUnit" class="d-flex align-items-center">
          <label for="unit" class="form-label" style="margin-right: 25px"
            >Unit:</label
          >
          <select class="form-select border border-dark" name="unitid" disabled>
            <option
              *ngFor="let unit of units"
              [value]="unit.Id"
              style="width: 350px"
              [selected]="unit.Id === trainDetails.Units"
            >
              {{ unit.UnitName }}
            </option>
          </select>
        </div> -->
      </div>
      <div style="height: 15px"></div>
    </div>

    <!-- <div class="row" style="margin-top: 7px" *ngIf="showDvUnit">
      <div class="col-12 d-flex align-items-center">
        <label for="unit" class="form-label" style="margin-right: 25px"
          >Unit:</label
        >
        <select
          class="form-select border border-dark"
          name="unitid"
          style="width: 200px"
          disabled
        >
          <option
            *ngFor="let unit of units"
            [value]="unit.Id"
            [selected]="unit.Id === trainDetails.Units"
          >
            {{ unit.UnitName }}
          </option>
        </select>
      </div>
    </div> -->

    <div class="col-12" style="margin-top: 10px" *ngIf="showDownload">
      <div class="d-flex align-items-center flex-wrap gap-2">
        <div class="d-flex align-items-center">
          <label class="text-muted mb-0 me-1">Rows</label>
          <select [(ngModel)]="queryParamcalc.PageSize" (change)="onPageSizeChangecalc()" id="PageSize" class="form-select" style="width: auto;">
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
          </select>
        </div>

        <div class="d-flex align-items-center ms-3">
          <label class="text-muted mb-0 me-1">View:</label>
          <div class="btn-group">
            <button class="btn stage-selector" (click)="showCalc()" [class.active]="showTableCalc">Calculated</button>
            <button class="btn stage-selector" (click)="showRaw()" [class.active]="showTable">Raw</button>
          </div>
        </div>

        <div class="d-flex align-items-center ms-3">
          <label class="text-muted mb-0 me-1">Stage:</label>
          <div class="btn-group">
            <button *ngIf="trainDetails?.Stages >= 1" 
                    class="btn stage-selector" (click)="showstageone()" [class.active]="!stages1">1</button>
            <button *ngIf="trainDetails?.Stages >= 2" 
                    class="btn stage-selector" (click)="showstagetwo()" [class.active]="!stages2">2</button>
            <button *ngIf="trainDetails?.Stages >= 3" 
                    class="btn stage-selector" (click)="showstagethree()" [class.active]="!stages3">3</button>
            <button *ngIf="trainDetails?.Stages >= 2" 
                    class="btn stage-selector" (click)="showstagetotal()" [class.active]="!total">Total</button>
          </div>
        </div>

        <button class="btn custom-buttons" (click)="downloadexport(trainDetails.Id)">Download Export</button>
        <button class="btn custom-buttons" [routerLink]="['/opdata', 'opdata-add']">Add Data</button>
        <button class="btn custom-buttons" [routerLink]="['/opdata', 'import']">Import Data</button>
        
        <button class="btn custom-delete-btn" (click)="softdelete()" *ngIf="OpdataCalcIds.length > 0">
          Delete Selected Data
        </button>
        
        <button type="button" class="btn custom-buttons" (click)="Undo()" *ngIf="this.opdataWithFlagD.length > 0 || this.opdataWithFlagI.length > 0">
          Undo
        </button>

        <div class="ms-auto d-flex">
          <div class="input-group" style="width: 250px;">
            <input type="text" class="form-control" [(ngModel)]="queryParamcalc.SearchQuery" id="searchQuery" placeholder="Search" />
            <button class="btn btn-outline-dark" (click)="searchtable()"><i class="fa fa-search"></i></button>
          </div>
        </div>
      </div>
    </div>

    <div style="min-height: 20px"></div>
    <div [hidden]="showTableCalc" id="dvRaw"></div>
    <div [hidden]="showTable" id="divCalc" style="overflow-y: hidden">


      <!-- TABLE START -->

      <table class="table table-bordered" width="100%" style="overflow-y: hidden"
        *ngIf="calcOpdata && calcOpdataList.length > 0">
        <!-- TABLE HEADING START -->

        <thead *ngIf="total && trainDetails.Units != 0">
          <tr>
            <th>
              <!-- <button
                type="button"
                class="fa fa-trash-o"
                (click)="softdelete()"
              ></button> -->
              <input type="checkbox" class="custom-checkbox" [(ngModel)]="masterSelected" (change)="selectAllRows()" />
            </th>
            <th>
              Date
              <i (click)="onSortClickcalc($event, 'Datetime')" class="my-icon fa fa-chevron-up"></i>
            </th>
            <th>
              Time
              <i (click)="onSortClickcalc($event, 'Datetime')" class="my-icon fa fa-chevron-up"></i>
            </th>
            <th>Feed Temp(&deg;C)</th>
            <th>TCF(Water)</th>
            <th>TCF(Salt)</th>
            <th>Feed Flow(gpm)</th>
            <th>Recovery(%)</th>
            <th>Flux(gfd)</th>
            <th>Diff Press (psi)</th>
            <th>Feed TDS(ppm)</th>
            <th>Perm TDS(ppm)</th>
            <th>CPF</th>
            <th>AFTDS(ppm)</th>
            <th>AFOP (psi)</th>
            <th>POP (psi)</th>
            <th>Net Driving Press (psi)</th>
            <th>A Value(gfd/psi)</th>
            <th>B Value(m/s)</th>
            <th>NPF(gpm)</th>
            <th>NSP(%)</th>
            <th>Norm Diff Press (psi)</th>
          </tr>
        </thead>

        <thead *ngIf="total && trainDetails.Units == 0">
          <tr>
            <th>
              <!-- <button
                type="button"
                class="fa fa-trash-o"
                (click)="softdelete()"
              ></button> -->
              <input type="checkbox" class="custom-checkbox" [(ngModel)]="masterSelected" (change)="selectAllRows()" />
            </th>
            <th>
              Date
              <i (click)="onSortClickcalc($event, 'Datetime')" class="my-icon fa fa-chevron-up"></i>
            </th>
            <th>
              Time
              <i (click)="onSortClickcalc($event, 'Datetime')" class="my-icon fa fa-chevron-up"></i>
            </th>
            <th>Feed Temp(&deg;C)</th>
            <th>TCF(Water)</th>
            <th>TCF(Salt)</th>
            <th>Feed Flow(m3/hr)</th>
            <th>Recovery(%)</th>
            <th>Flux(lmh)</th>
            <th>Diff Press(bar)</th>
            <th>Feed TDS(ppm)</th>
            <th>Perm TDS(ppm)</th>
            <th>CPF</th>
            <th>AFTDS(ppm)</th>
            <th>AFOP(bar)</th>
            <th>POP(bar)</th>
            <th>Net Driving Press(bar)</th>
            <th>A Value(gfd/psi)</th>
            <th>B Value(m/s)</th>
            <th>NPF(m3/hr)</th>
            <th>NSP(%)</th>
            <th>Norm Diff Press(bar)</th>
          </tr>
        </thead>

        <thead *ngIf="!total && trainDetails.Units != 0">
          <tr>
            <th>
              <!-- <button
                type="button"
                class="fa fa-trash-o"
                (click)="softdelete()"
              ></button> -->
              <input type="checkbox" class="custom-checkbox" [(ngModel)]="masterSelected" (change)="selectAllRows()" />
            </th>
            <th>
              Date
              <i (click)="onSortClickcalc($event, 'Datetime')" class="my-icon fa fa-chevron-up"></i>
            </th>
            <th>
              Time
              <i (click)="onSortClickcalc($event, 'Datetime')" class="my-icon fa fa-chevron-up"></i>
            </th>
            <th>Feed Temp(&deg;C)</th>
            <th>TCF(Water)</th>
            <th>TCF(Salt)</th>
            <th>Feed Flow (gpm)</th>
            <th>Permeate Flow (gpm)</th>
            <th>Concentrate Flow (gpm)</th>
            <th>Permeate Conductivity (µS/cm)</th>
            <th>Recovery(%)</th>
            <th>Flux(gfd)</th>
            <th>Diff Press (psi)</th>
            <th>TMP (psi)</th>
            <th>Feed TDS(ppm)</th>
            <th>Perm TDS(ppm)</th>
            <th>CPF</th>
            <th>AFTDS(ppm)</th>
            <th>AFOP (psi)</th>
            <th>POP (psi)</th>
            <th>Net Driving Press (psi)</th>
            <th>A Value(gfd/psi)</th>
            <th>B Value(m/s)</th>
            <th>NPF(m3/hr)</th>
            <th>NSP(%)</th>
            <th>Norm Diff Press (psi)</th>
          </tr>
        </thead>

        <thead *ngIf="!total && trainDetails.Units == 0">
          <tr>
            <th>
              <!-- <button
                type="button"
                class="fa fa-trash-o"
                (click)="softdelete()"
              ></button> -->
              <input type="checkbox" class="custom-checkbox" [(ngModel)]="masterSelected" (change)="selectAllRows()" />
            </th>
            <th>
              Date
              <i (click)="onSortClickcalc($event, 'Datetime')" class="my-icon fa fa-chevron-up"></i>
            </th>
            <th>
              Time
              <i (click)="onSortClickcalc($event, 'Datetime')" class="my-icon fa fa-chevron-up"></i>
            </th>
            <th>Feed Temp(&deg;C)</th>
            <th>TCF(Water)</th>
            <th>TCF(Salt)</th>
            <th>Feed Flow (m3/hr)</th>
            <th>Permeate Flow (m3/hr)</th>
            <th>Concentrate Flow (m3/hr)</th>
            <th>Permeate Conductivity (µS/cm)</th>
            <th>Recovery(%)</th>
            <th>Flux(lmh)</th>
            <th>Diff Press (bar)</th>
            <th>TMP (bar)</th>
            <th>Feed TDS(ppm)</th>
            <th>Perm TDS(ppm)</th>
            <th>CPF</th>
            <th>AFTDS(ppm)</th>
            <th>AFOP(bar)</th>
            <th>POP(bar)</th>
            <th>Net Driving Press(bar)</th>
            <th>A Value(gfd/psi)</th>
            <th>B Value(m/s)</th>
            <th>NPF(m3/hr)</th>
            <th>NSP(%)</th>
            <th>Norm Diff Press(bar)</th>
          </tr>
        </thead>

        <!-- TABLE HEADING END -->

        <tbody [hidden]="stages1">
          <tr *ngFor="
              let calcOpdata of calcOpdataList
                | paginate
                  : {
                      itemsPerPage: pageHeaderscalc.PageSize,
                      currentPage: pageHeaderscalc.PageNumber,
                      totalItems: pageHeaderscalc.TotalItems
                    }
            ">
            <td>
              <!-- <input
                type="checkbox"
                id="NouserSelected"
                name="NouserSelected"
                (change)="selectednoOtherUser(calcOpdata.Id)"
              /> -->
              <input type="checkbox" class="custom-checkbox" [checked]="isRowSelected(calcOpdata.Id)"
                (change)="selectednoOtherUser(calcOpdata.Id)" />
            </td>
            <td style="text-wrap: nowrap">
              <a class="text-black" (click)="navigate(calcOpdata.OpdatId)">
                {{ calcOpdata.Datetime | date : "yyyy-MM-dd" }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.Datetime | date : "HH:mm:ss"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.FeedTemp | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TcfWater | number : "1.3-3"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TcfSalt | number : "1.3-3"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S1FeedFlow | number : "1.2-2"
                }}</a>
            </td>

            <td>
              <a class="text-black">{{ calcOpdata.S1Recovery * 100 | number : "1.2-2" }}%</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S1Flux | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S1DiffPressure | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S1FeedTds | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S1PermTds | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S1Cpf | number : "1.3-3"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S1Aftds | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S1AvgFeedOp | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S1Pop | number : "1.3-3"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S1NetDrivePressure | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S1AVal | number : "1.4-4"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S1BVal | scientificNotation
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S1Npf | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{ calcOpdata.S1Nsp * 100 | number : "1.3-3"
                }}%</a><!--{{ calcOpdata.S1Nsp | number : "1.3-3" }}  -->
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S1NormDiffPress | number : "1.2-2"
                }}</a>
            </td>
          </tr>
        </tbody>

        <!-- table body for stage 2 -->
        <tbody [hidden]="stages2">
          <tr *ngFor="
              let calcOpdata of calcOpdataList
                | paginate
                  : {
                      itemsPerPage: pageHeaderscalc.PageSize,
                      currentPage: pageHeaderscalc.PageNumber,
                      totalItems: pageHeaderscalc.TotalItems
                    }
            ">
            <td>
              <!-- <input
                type="checkbox"
                id="NouserSelected"
                name="NouserSelected"
                (change)="selectednoOtherUser(calcOpdata.Id)"
              /> -->
              <input type="checkbox" class="custom-checkbox" [checked]="isRowSelected(calcOpdata.Id)"
                (change)="selectednoOtherUser(calcOpdata.Id)" />
            </td>
            <td style="text-wrap: nowrap">
              <a class="text-black" (click)="navigate(calcOpdata.OpdatId)">{{
                calcOpdata.Datetime | date : "yyyy-MM-dd"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.Datetime | date : "HH:mm:ss"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.FeedTemp | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TcfWater | number : "1.3-3"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TcfSalt | number : "1.3-3"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S2FeedFlow | number : "1.2-2"
                }}</a>
            </td>

            <td>
              <a class="text-black">{{ calcOpdata.S2Recovery * 100 | number : "1.2-2" }}%</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S2Flux | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S2DiffPressure | number : "1.2-2"
                }}</a>
            </td>

            <td>
              <a class="text-black">{{
                calcOpdata.S2FeedTds | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S2PermTds | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S2Cpf | number : "1.3-3"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S2Aftds | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S2AvgFeedOp | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S2Pop | number : "1.3-3"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S2NetDrivPress | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S2AVal | number : "1.4-4"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S2BVal | scientificNotation
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S2Npf | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{ calcOpdata.S2Nsp * 100 | number : "1.3-3" }}%</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S2NormDiffPress | number : "1.2-2"
                }}</a>
            </td>
          </tr>
        </tbody>
        <!-- table body for stage 2 end -->

        <!-- table body for stage 3 -->
        <tbody [hidden]="stages3">
          <tr *ngFor="
              let calcOpdata of calcOpdataList
                | paginate
                  : {
                      itemsPerPage: pageHeaderscalc.PageSize,
                      currentPage: pageHeaderscalc.PageNumber,
                      totalItems: pageHeaderscalc.TotalItems
                    }
            ">
            <td>
              <!-- <input
                type="checkbox"
                id="NouserSelected"
                name="NouserSelected"
                (change)="selectednoOtherUser(calcOpdata.Id)"
              /> -->
              <input type="checkbox" class="custom-checkbox" [checked]="isRowSelected(calcOpdata.Id)"
                (change)="selectednoOtherUser(calcOpdata.Id)" />
            </td>
            <td style="text-wrap: nowrap">
              <a class="text-black" (click)="navigate(calcOpdata.OpdatId)">{{
                calcOpdata.Datetime | date : "yyyy-MM-dd"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.Datetime | date : "HH:mm:ss"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.FeedTemp | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TcfWater | number : "1.3-3"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TcfSalt | number : "1.3-3"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S3FeedFlow | number : "1.2-2"
                }}</a>
            </td>

            <td>
              <a class="text-black">{{ calcOpdata.S3Recovery * 100 | number : "1.2-2" }}%</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S3Flux | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S3DiffPressure | number : "1.2-2"
                }}</a>
            </td>

            <td>
              <a class="text-black">{{
                calcOpdata.S3FeedTds | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S3PermTds | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S3Cpf | number : "1.3-3"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S3AvgFeedTds | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S3AvgFeedOp | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S3Pop | number : "1.3-3"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S3NetDrivPress | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S3AVal | number : "1.4-4"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S3BVal | scientificNotation
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S3Npf | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{ calcOpdata.S3Nsp * 100 | number : "1.3-3" }}%</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.S3NormDiffPress | number : "1.2-2"
                }}</a>
            </td>
          </tr>
        </tbody>
        <!-- table body for stage 2 end -->

        <!-- table body for stage 3 -->
        <tbody [hidden]="total">
          <tr *ngFor="
              let calcOpdata of calcOpdataList
                | paginate
                  : {
                      itemsPerPage: pageHeaders.PageSize,
                      currentPage: pageHeaders.PageNumber,
                      totalItems: pageHeaders.TotalItems
                    }
            ">
            <td>
              <!-- <input
                type="checkbox"
                id="NouserSelected"
                name="NouserSelected"
                (change)="selectednoOtherUser(calcOpdata.Id)"
              /> -->
              <input type="checkbox" class="custom-checkbox" [checked]="isRowSelected(calcOpdata.Id)"
                (change)="selectednoOtherUser(calcOpdata.Id)" />
            </td>
            <td style="text-wrap: nowrap">
              <a class="text-black" (click)="navigate(calcOpdata.OpdatId)">{{
                calcOpdata.Datetime | date : "yyyy-MM-dd"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.Datetime | date : "HH:mm:ss"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.FeedTemp | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TcfWater | number : "1.3-3"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TcfSalt | number : "1.3-3"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalFeedFlow | number : "1.2-2"
                }}</a>
            </td>

            <td>
              <a class="text-black">{{
                calcOpdata.TotalPermFlow | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalConcFlow | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalPermCond | number : "1.2-2"
                }}</a>
            </td>

            <td>
              <a class="text-black">{{ calcOpdata.TotalRecovery * 100 | number : "1.2-2" }}%</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalFlux | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalDiffPressure | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalTmp | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalFeedTds | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalPermTds | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalCpf | number : "1.3-3"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalAvgFeedTds | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalAvgFeedOp | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalPop | number : "1.3-3"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalNetDrivPress | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalAVal | number : "1.4-4"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalBVal | scientificNotation
                }}</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalNpf | number : "1.2-2"
                }}</a>
            </td>
            <td>
              <a class="text-black">{{ calcOpdata.TotalNsp * 100 | number : "1.3-3" }}%</a>
            </td>
            <td>
              <a class="text-black">{{
                calcOpdata.TotalNormDiffPress | number : "1.2-2"
                }}</a>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- TABLE END -->

      <div class="d-flex bd-highlight">
        <div class="p-2 flex-grow-1 bd-highlight">
          Showing total

          {{ pageHeaderscalc.TotalItems }} entries
        </div>
        <div class="p-2 bd-highlight" *ngIf="pageHeaderscalc.TotalItems > 10">
          <pagination-controls (pageChange)="onPageChangecalc($event)" class="my-pagination"></pagination-controls>
        </div>
      </div>
    </div>
  </div>
</div>
<div style="min-height: 100px"></div>